export const styles = theme => ({

  // color
  statusBox: {
    fontSize: '14px',
    padding: theme.spacing((1/2), 1),
    alignItems: 'center',
    borderRadius: 6,
    fontWeight: 'bold',
  },
  boxContent: {
    border: '1px solid #ccc',
  },
  title: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '16px',
    fontWeight: '400',
  },
    // color
    color0: {
      background: '#AED3FF',
      constrastColor: '#000',
    },
    color10: {
      background: '#AEECB7',
      constrastColor: '#000',
    },
    color20: {
      background: '#80C63D',
      constrastColor: '#000',
    },
    color35: {
      background: '#F0D447',
      constrastColor: '#000',
    },
    color50: {
      background: '#F08F36',
      constrastColor: '#000',
    },
    color70: {
      color: '#fff',
      background: '#BE6B27',
      constrastColor: '#fff',
    },
    color90: {
      color: '#fff',
      background: '#DB352E',
      constrastColor: '#fff',
    },
});